import React, { Suspense, lazy } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import DashboardContainer from './pages/Assessment/components/DashboardContainer';
// import NotFoundPage from './pages/404/NotFoundPage';
// import ManageFolder from './pages/ManageFolder/ManageFolder';
// import FolderManagement from './pages/FolderManagement/FolderManagement';
// import ManageSaveSearch from './pages/ManageSaveSearch/ManageSaveSearch';
// import Header from './components/header/header';

const ManageFolder = lazy(() => import('./pages/ManageFolder/ManageFolder'));
const FolderManagement = lazy(() => import('./pages/FolderManagement/FolderManagement'));
const ManageSaveSearch = lazy(() => import('./pages/ManageSaveSearch/ManageSaveSearch'));
const Assessment = lazy(() => import('./pages/FolderManagement/Assessment/Assessment'));
const NotFoundPage = lazy(() => import('./pages/404/NotFoundPage'));

type RoutesProps = {
  
  onNotificationToast ?: (message: string) => void;
  onProcessingToast ?: (message:string, status:boolean) =>void
  onErrorToast?: (message:string) =>void
};
function AppRouter(props: RoutesProps) {
  const {onNotificationToast,onProcessingToast,onErrorToast} =props
  return (
    <Router>
      {/* <Header/> */}
      <Suspense>
      <Routes>
        <Route path='/edge/foldermanagement/manage-folder' element={<ManageFolder />} />
        <Route path='/edge/foldermanagement/assessment/dashboard' element={<DashboardContainer />} />
        <Route path='/edge/foldermanagement' element={<FolderManagement onErrorToast={onErrorToast} onNotificationToast={onNotificationToast} onProcessingToast={onProcessingToast}/>} />
        <Route path='/edge/foldermanagement/manage-save-search' element={<ManageSaveSearch/>} />
        <Route path='/edge/foldermanagement/assessment' element={<Assessment/>} />
        <Route path='*' element={<NotFoundPage />} />
        <Route path="/edge/foldermanagement/error" element={<NotFoundPage />} />
      </Routes>
      </Suspense>
    </Router>
  )
}

export default AppRouter